<template>
  <div class="user">
    <!-- 搜索框保持不变 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="用工类型名称">
          <el-input placeholder="请输入用工类型名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getTreeData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加工种类型</el-button>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <!-- 树形表格 -->
        <el-table 
          size="small" 
          :data="tableData" 
          row-key="employment_type_id" 
          default-expand-all 
          :tree-props="{children: 'child'}"
          border 
          style="width: 100%" 
          v-loading="loading">
          
          <el-table-column prop="name" label="工种类型名称"></el-table-column>
          <el-table-column prop="sort" label="排序" width="100"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :employment_type_id="employment_type_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import Employment_typeApi from '@/api/employment_type.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  data() {
    return {
      loading: true,
      tableData: [], // 树形数据
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      employment_type_id: "",
    };
  },
  created() {
    this.getTreeData();
  },
  methods: {
    /*获取树形列表*/
    getTreeData() {
      let self = this;
      self.loading = true;
      Employment_typeApi.treeList(this.formInline, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list; // 树形结构数据
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    /*搜索查询*/
    getData() {
      this.getTreeData();
    },
    
    /*添加*/
    addClick() {
      this.open_add = true;
    },
    
    /*编辑*/
    editClick(row) {
      this.employment_type_id = row.employment_type_id;
      this.open_edit = true;
    },
    
    /*删除*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Employment_typeApi.del({ employment_type_id: row.employment_type_id }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({ message: '删除成功', type: 'success' });
              self.getTreeData(); // 刷新树形列表
            }
          });
      });
    },
    
    closeAdd(e) {
      this.open_add = false;
      this.getTreeData();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTreeData();
    }
  }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/plus/employment_type/index/index.vue